import {
  fetchChatsBulkOperationsRestoreAllFromArchiveDesktop,
  TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse,
} from '../../repositories/chats/v1/chats/bulk-operations/restore-all-from-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { toggleChatListPending } from '../chatList/actions';

const DEFAULT_ERROR_MESSAGE = 'Не удалось восстановить из архива все чаты';

/**
 * Восстановить из архива все чаты
 */
export const restoreAllChatsFromArchive = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { httpApi, logger } = context;

  dispatch(toggleChatListPending(true));

  try {
    const { statusCode, response }: TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse =
      await fetchChatsBulkOperationsRestoreAllFromArchiveDesktop({
        httpApi,
        config: { requestConfig: { withCredentials: true } },
      });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chat,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }
  } catch (ex) {
    const exception = getGenericLikeError({
      error: ex,
      domain: EExceptionDomain.Chat,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/chats/bulk-operations/restore-all-from-archive-desktop/',
    });

    dispatch(showAlert({ message: DEFAULT_ERROR_MESSAGE }));
  } finally {
    dispatch(toggleChatListPending(false));
  }
};
